/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */

type configType = Record<string, {
    flag: boolean,
    fn: (e?: { [key: string]: any }) => any
}>
type devConfigType = Partial<Record<'showLoading' | 'needLogin' | 'showErr' | 'repeatCancel', boolean>>


import axios from 'axios';
import qs from 'qs';
import { defaultLang } from '@/i18n'




// store imports removed from here to avoid unused-import lint warnings
import { comUrl } from '@/config';
import { showToast, hideToast } from "@/components/Toast"

// axios.defaults.baseURL = comUrl
// 请求超时时间
axios.defaults.timeout = 10000;
// 解决跨域
axios.defaults.withCredentials = false;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// pending CancelToken 用于阻止重复请求
const pending: { [key: string]: (str: string) => void } = {}
const CancelToken = axios.CancelToken






// 项目开发的额外配置
const initConfig = (): configType => {
    return {
        //接口请求拦截配置

        //是否显示loading加载图 
        showLoading: {
            flag: false,
            fn: () => {
                showToast({
                    type: 'loading',
                    time: 5
                })
                // console.log('显示loading图')
            }
        },
        //是否需要登录才能请求
        needLogin: {
            flag: false,
            fn: () => {
                console.error('需要登录才能执行请求')
            }
        },
        //是否开启拦截重复请求
        repeatCancel: {
            flag: true,
            fn: () => {
                console.log('拦截重复请求')
            }
        },





        //接口响应拦截配置


        //是否显示接口错误提示
        showErr: {
            flag: false,
            fn: (obj: any) => {
                const { msg } = obj
                console.error('展示错误', msg)
                // showToast(msg)
                hideToast()
                setTimeout(() => {
                    showToast({
                        type: 'error',
                        content: msg
                    })
                }, 100)
            }
        },
    }
}

let defaultConfig: any = {}






// 拦截重复请求
const removePending = (key: string, isRequest = false) => {
    if (pending[key] && isRequest) {
        pending[key]('取消重复请求') // 执行CancelToken，用于取消进行中的请求
    }
    delete pending[key]
}

const setUrl = (config: any, isReuest = false) => {
    // request的时候，config.url是action路径；response的时候，config.url是全路径。所以存在判断请求操作从而处理url
    let url = config.url
    if (isReuest) {
        url = config.baseURL + config.url.substring(1, config.url.length)
    }
    return config.method === 'get' || config.method === 'delete' ? encodeURIComponent(url + JSON.stringify(config.params)) : encodeURIComponent(url + JSON.stringify(config.data))
}



/**
 * 封装请求拦截器
 * @param {*拦截回调} interceptorFun 
 * @param {*错误回调} errorFun 
 */
function setRequestInterceptor(interceptorFun: (params: any) => any, errorFun: (err: any) => any) {
    return axios.interceptors.request.use(interceptorFun, errorFun)
}
// 执行请求拦截
setRequestInterceptor(
    config => {
        const {
            flag
        } = defaultConfig.repeatCancel
        
        // 如果config中已经有headers，则合并，否则创建新的headers
        // 对于form表单请求（multipart/form-data），保留原有的Content-Type
        const isFormData = config.data instanceof FormData
        config.headers = {
            ...config.headers,
            'Content-Type': isFormData ? 'multipart/form-data' : 'application/x-www-form-urlencoded',
        //     // 'X-Requested-With': 'XMLHttpRequest'
        }
        // 只有自己的请求才需要在请求头加上Lang
        if (config.url.includes(comUrl)) {
            config.headers['Lang'] = localStorage.getItem('locale') || defaultLang
        }

        
        // 拦截重复请求(即当前正在进行的相同请求)
        const requestData = setUrl(config, flag)
        removePending(requestData, flag)
        config.cancelToken = new CancelToken((c) => {
            pending[requestData] = c
        })
        return config
    },
    error => {
        return Promise.reject(error)
    }
)


/**
 * 封装添加响应拦截器方法
 * @param interceptorFun
 * @param errorFun
 * @returns {Interceptor}
 */
function setResponseInterceptor(interceptorFun: (params: any) => any, errorFun: (err: any) => any) {
    return axios.interceptors.response.use(interceptorFun, errorFun)

}
// 执行响应拦截
setResponseInterceptor(
    response => {

        // 把已经完成的请求从 pending 中移除
        const requestData = setUrl(response.config)
        removePending(requestData)
        const status = response.status
        const code = response.data.code
        const msg = response.data.msg

        if (defaultConfig.showLoading.flag) {
            hideToast()
        }

        if (code !== 200) {
            if (defaultConfig.showErr.flag) {
                // 展示错误提示
                defaultConfig.showErr.fn({ status, msg })
            }
            // 登录超时 弹出登录框
            if (code == 1009) {
                // showLogin()
            }
        }
        return response
    }, error => {
        if (error && error.response) {
            const status = error.response.status
            const getMsg = new Map([
                [400, '错误请求'],
                [401, '未授权，请重新登录'],
                [403, '拒绝访问'],
                [404, '请求错误,未找到该资源'],
                [405, '请求方法未允许'],
                [408, '请求超时'],
                [500, '服务器端出错'],
                [501, '网络未实现'],
                [502, '网络错误'],
                [503, '服务不可用'],
                [504, '网络超时'],
                [505, 'http版本不支持该请求'],
            ])
            error.message = getMsg.get(status) || `连接错误${status}`

            if (defaultConfig.showErr.flag) {
                // 展示错误提示
                defaultConfig.showErr.fn && defaultConfig.showErr.fn({ status, msg: error.message })
            }

        } else {
            // 请求超时
            if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
                console.error('连接请求超时')
            }
        }
        return Promise.reject(error)
    }
)



/**
 * 封装请求方法
 * @param method
 * @param url
 * @param params
 * @param devConfig 项目开发额外配置，例如是否需要重复请求，是否需要登录，是否需要展示错误提示框
 * @param contentType 自定义Content-Type，用于form表单等特殊请求
 * @returns {Promise}
 */
function methodAxios(method: 'GET' | 'POST' | 'PUT' | 'DELETE', url: string, params: { [key: string]: any } = {}, devConfig: { [key: string]: boolean } = {}, contentType?: string): Promise<{
    code: number
    data?: any
    msg?: string
}> {
    const todoType = ['showLoading', 'needLogin']

    defaultConfig = initConfig() // 重置 defaultConfig
    for (const i in defaultConfig) {
        // devConfig有填入自定义的东西，例如showLoading的话，就替换掉defaultConfig的showLoading
        if (typeof devConfig[i] === "boolean") {
            // flag = devConfig[i]
            defaultConfig[i].flag = devConfig[i]
        }
        if (todoType.includes(i) && defaultConfig[i].flag) {
            const { fn } = defaultConfig[i]
            if (fn) {
                const res = fn()
                if (res === false) {
                    return Promise.resolve({ code: 500 })
                }
            }
        }
    }
    const type = Object.prototype.toString.call(params).slice(8, -1)
    const httpDefault: any = {
        method,
        url,
        params: method === 'GET' || method === 'DELETE' ? params : null,
        data: method === 'POST' || method === 'PUT' ? (type === 'FormData' ? params : qs.stringify(params)) : null
    }
    
    // 如果指定了自定义Content-Type，则设置headers
    if (contentType) {
        httpDefault.headers = {
            'Content-Type': contentType
        }
    }
    
    const requestConfig = Object.assign({}, httpDefault)
    // 这个其实可以直接return axios(requestConfig)，为何需要再增加一层Promise？
    // 这里是有原因的：
    // 1、如果直接return axios(requestConfig)，请求成功或失败的处理是交由使用者
    // 2、这里封装多一层Promise，是便于此处封装时考虑添加公共处理如开启遮罩层关闭遮罩层，之后才抛出调用结果给调用方，而不应该由调用方赖关闭遮罩层
    return new Promise((resolve, reject) => {
        axios(requestConfig)
            .then((response) => {
                resolve(response.data)
            }).catch((error) => {
                reject(error)
            }).finally(() => {
                null
            })
    })
}



export default {
    get: (url: string, params: { [key: string]: any }, devConfig?: devConfigType) => methodAxios('GET', url, params, devConfig),
    post: (url: string, params: { [key: string]: any }, devConfig?: devConfigType) => methodAxios('POST', url, params, devConfig),
    put: (url: string, params: { [key: string]: any }, devConfig?: devConfigType) => methodAxios('PUT', url, params, devConfig),
    delete: (url: string, params: { [key: string]: any }, devConfig?: devConfigType) => methodAxios('DELETE', url, params, devConfig),
}



